import user from "../user";

/**
 * Importante:
 *
 * Funcionalmente el redactor quiere poder alternar en modo preview entre partner y usuario
 * normal. Como la preview la cargamos metiendo la URL de la preview en un iframe del CMS,
 * si el usuario tiene las cookies en el navegador, la preview se pinta con esos valores.
 *
 * De esta manera "sobreescribimos" el valor de las cookies de control de usuario, descritas más arriba
 *
 * Para más info https://mgr.bitban.com/issues/70788
 */
const { partner } = document.body.dataset;

if (partner !== undefined) {
  if (parseInt(partner)) {
    user.userType = 4;
  } else {
    user.userType = 0;
  }
}
// Engañamos al JS para que pinte el modo "no partner" en vertele siempre
if (user.isPartner) {
  document.body.classList.add('partner');
}
document.body.removeAttribute('style');

if (!!user.id) {
  document.querySelector('.bulletin')?.classList.add('hide');
}

const userMenu = document.querySelector('.edi-user-menu');
const auth = {
  loginUrl: userMenu?.dataset.loginUrl || null,
  redirectUrl: userMenu?.dataset.redirectUrl || null,
  partnerUrl: userMenu?.dataset.partnerUrl || null,
  profileUrl: userMenu?.dataset.profileUrl || null,
  increaseQuotaUrl: userMenu?.dataset.increaseQuotaUrl || null,
  registerUrl: userMenu?.dataset.registerUrl || null,
};

export {
  user,
  auth
};
